// extracted by mini-css-extract-plugin
module.exports = {"flag":"index_flag_1baN7"};